export class AutocompleteModel {
  value: number | string;

  label: string;

  constructor(value: number | string, label: string) {
    this.value = value;
    this.label = label;
  }
}
